import axios from '../utils/axios';

const MohReportDataService = {
    // Finance
    getFinance:    (params = {}) => axios.get('moh-report/data/finance', { params }),
    saveFinance:   (data)        => axios.post('moh-report/data/finance/save', data),
    deleteFinance: (id)          => axios.post('moh-report/data/finance/delete', { id }),

    // HR Establishment
    getHr:    (params = {}) => axios.get('moh-report/data/hr', { params }),
    saveHr:   (data)        => axios.post('moh-report/data/hr/save', data),
    deleteHr: (id)          => axios.post('moh-report/data/hr/delete', { id }),

    // Clinical Services
    getClinical:    (params = {}) => axios.get('moh-report/data/clinical', { params }),
    saveClinical:   (data)        => axios.post('moh-report/data/clinical/save', data),
    deleteClinical: (id)          => axios.post('moh-report/data/clinical/delete', { id }),

    // Fleet
    getFleet:    (params = {}) => axios.get('moh-report/data/fleet', { params }),
    saveFleet:   (data)        => axios.post('moh-report/data/fleet/save', data),
    deleteFleet: (id)          => axios.post('moh-report/data/fleet/delete', { id }),

    // Summary — line counts for a given unit + period, used for the tab badges
    getSummary: (params = {}) => axios.get('moh-report/data/summary', { params }),

    // Report generation — returns a raw docx blob to download, not JSON.
    generateReport: (params = {}) => axios.get('moh-report/data/generate', { params, responseType: 'blob' }),
};

export default MohReportDataService;